import { createContext, ReactNode } from "react";

// Carries the wallet buttons (Apple Pay / Google Pay / PayPay / PayNow) into
// FormTemplate so they render in normal flow at the top of the form card.
// data-driven-forms only passes formFields/schema to FormTemplate, and wrapping
// FormTemplate in a closure would remount the form on every render.
export const WalletButtonsContext = createContext<ReactNode>(null);
